module.exports = __webpack_public_path__ + "img/sld_mppt_2_t1_b1_green.0bc4d5e4.svg";